import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import theme from "../../utils/theme";
import AppButton from "./AppButton";

const styles = {
  popup: {
    minWidth: 400,
    borderRadius: 8,
  },
  title: {
    padding: "24px 24px 16px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    bgcolor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  content: {
    padding: 4,
    textAlign: "center",
  },
  actions: {
    padding: "16px 24px 24px",
    justifyContent: "space-between",
  },
  deleteButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
};

const DeleteConfirmationPopup = ({
  open,
  onClose,
  onConfirm,
  itemName,
  isLoading = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} sx={styles.popup}>
      <DialogTitle sx={styles.title}>
        <Typography variant="h4">Confirm Delete</Typography>
      </DialogTitle>
      <DialogContent sx={styles.content}>
        <Typography variant="h5">
          Are you sure you want to delete{" "}
          <b style={{ color: theme.palette.primary.main }}>{itemName + "?"}</b>
        </Typography>
        <Typography
          variant="body2"
          sx={{ mt: 2, color: theme.palette.error.dark }}
        >
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <AppButton
          buttonType="greyed"
          onClick={onClose}
          label="Cancel"
          disabled={isLoading}
        />
        <AppButton
          buttonType="primary"
          onClick={onConfirm}
          startIcon={<DeleteIcon />}
          sx={{ minWidth: 120, mx: 1 }}
          label="Delete"
          isLoading={isLoading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationPopup;
